import apiClient from '../axios.js'

/**
 * 角色管理 API
 */
export const rolesService = {
    /**
     * 獲取角色列表
     * @param {Object} params - 查詢參數
     * @param {number} params.page - 頁碼
     * @param {number} params.pageSize - 每頁數量
     * @param {string} params.search - 搜尋關鍵字
     * @param {string} params.accountType - 帳號類型篩選（system, platform, client_owner, staff）
     * @param {string} params.status - 狀態篩選（active, inactive）
     * @returns {Promise<Object>} 角色列表
     */
    getRoles: async (params = {}) => {
        const response = await apiClient.get('/system/roles', { params })
        return response
    },

    /**
     * 獲取單一角色詳情
     * @param {string} roleCode - 角色代碼
     * @returns {Promise<Object>} 角色詳情
     */
    getRole: async (roleCode) => {
        const response = await apiClient.get(`/system/roles/${roleCode}`)
        return response
    },

    /**
     * 新增角色
     * @param {Object} roleData - 角色資料
     * @param {string} roleData.roleCode - 角色代碼
     * @param {string} roleData.roleName - 角色名稱
     * @param {string} roleData.accountType - 適用帳號類型
     * @param {string} roleData.description - 角色說明
     * @param {string} roleData.status - 狀態（active, inactive）
     * @param {number} roleData.sortOrder - 排序順序
     * @returns {Promise<Object>} 創建的角色
     */
    createRole: async (roleData) => {
        const response = await apiClient.post('/system/roles', roleData)
        return response
    },

    /**
     * 更新角色
     * @param {string} roleCode - 角色代碼
     * @param {Object} roleData - 角色資料
     * @returns {Promise<Object>} 更新的角色
     */
    updateRole: async (roleCode, roleData) => {
        const response = await apiClient.put(`/system/roles/${roleCode}`, roleData)
        return response
    },

    /**
     * 刪除角色
     * @param {string} roleCode - 角色代碼
     * @returns {Promise<Object>} 刪除結果
     */
    deleteRole: async (roleCode) => {
        const response = await apiClient.delete(`/system/roles/${roleCode}`)
        return response
    },

    /**
     * 獲取角色的模組列表
     * @param {string} roleCode - 角色代碼
     * @returns {Promise<Array>} 模組列表
     */
    getRoleModules: async (roleCode) => {
        const response = await apiClient.get(`/system/roles/${roleCode}/modules`)
        return response
    },

    /**
     * 設定角色的模組
     * @param {string} roleCode - 角色代碼
     * @param {Array<string>} moduleIds - 模組 ID 列表
     * @returns {Promise<Array>} 更新後的模組列表
     */
    setRoleModules: async (roleCode, moduleIds) => {
        const response = await apiClient.put(`/system/roles/${roleCode}/modules`, { moduleIds })
        return response
    },

    /**
     * 根據帳號類型獲取角色列表（用於下拉選單）
     * @param {string} accountType - 帳號類型
     * @returns {Promise<Array>} 角色列表
     */
    getRolesByAccountType: async (accountType) => {
        // 使用新的 options 端點，權限要求較低
        const response = await apiClient.get(`/system/roles/options/${accountType}`)
        return response
    },
}
